"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28449],{

/***/ 28449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_CartManager; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./redux/actions/products.ts
var products = __webpack_require__(86730);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/actions/user.ts
var user = __webpack_require__(76809);
// EXTERNAL MODULE: ./redux/actions/promotions.ts + 1 modules
var promotions = __webpack_require__(18919);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/parameters.ts


var getParameters = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.root */.KU.root,
        uid: "brand/parameters"
    });
};

;// CONCATENATED MODULE: ./redux/actions/parameters.ts

var ACTIONS = {
    GET_PARAMETERS_REQUEST: 'GET_PARAMETERS_REQUEST',
    GET_PARAMETERS_SUCCESS: 'GET_PARAMETERS_SUCCESS',
    GET_PARAMETERS_FAILURE: 'GET_PARAMETERS_FAILURE'
};
var GET_PARAMETERS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PARAMETERS_REQUEST
    };
};
var GET_PARAMETERS_SUCCESS = function(parameters) {
    return {
        type: ACTIONS.GET_PARAMETERS_SUCCESS,
        parameters: parameters
    };
};
var GET_PARAMETERS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PARAMETERS_FAILURE,
        err: err
    };
};
function parameters_getParameters() {
    return function(dispatch) {
        dispatch(GET_PARAMETERS_REQUEST());
        return getParameters().then(function(response) {
            return dispatch(GET_PARAMETERS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PARAMETERS_FAILURE(err));
        });
    };
}

;// CONCATENATED MODULE: ./redux/services/countries.ts


var getCountries = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.countries */.KU.countries,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        isV2: true
    });
};

;// CONCATENATED MODULE: ./redux/actions/countries.tsx

var countries_ACTIONS = {
    GET_COUNTRIES_REQUEST: 'GET_COUNTRIES_REQUEST',
    GET_COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
    GET_COUNTRIES_FAILURE: 'GET_COUNTRIES_FAILURE'
};
var GET_COUNTRIES_REQUEST = function() {
    return {
        type: countries_ACTIONS.GET_COUNTRIES_REQUEST
    };
};
var GET_COUNTRIES_SUCCESS = function(countries) {
    return {
        type: countries_ACTIONS.GET_COUNTRIES_SUCCESS,
        countries: countries
    };
};
var GET_COUNTRIES_FAILURE = function(err) {
    return {
        type: countries_ACTIONS.GET_COUNTRIES_FAILURE,
        err: err
    };
};
function countries_getCountries() {
    return function(dispatch) {
        dispatch(GET_COUNTRIES_REQUEST());
        return getCountries().then(function(response) {
            return dispatch(GET_COUNTRIES_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_COUNTRIES_FAILURE(err));
        });
    };
}

// EXTERNAL MODULE: ./redux/actions/contract.ts + 1 modules
var contract = __webpack_require__(97506);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./managers/product/packManager.tsx
var getAssociatedProducts = function(associations) {
    var listAssociatedItems = [];
    (associations === null || associations === void 0 ? void 0 : associations.length) > 0 && (associations === null || associations === void 0 ? void 0 : associations.forEach(function(association) {
        if (association === null || association === void 0 ? void 0 : association.products) {
            listAssociatedItems.push(association === null || association === void 0 ? void 0 : association.products);
        }
    }));
    return listAssociatedItems;
};

// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(10285);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
// EXTERNAL MODULE: ./redux/actions/takeBack.ts + 1 modules
var takeBack = __webpack_require__(42738);
// EXTERNAL MODULE: ./redux/actions/wishList.ts + 1 modules
var wishList = __webpack_require__(94624);
;// CONCATENATED MODULE: ./components/CartManager.tsx
/* provided dependency */ var process = __webpack_require__(34155);



















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
dayjs_min_default().extend((customParseFormat_default()));
var mapStateToProps = function(state) {
    return {
        cart: state.cart,
        products: state.products,
        product: state.product,
        parameters: state.parameters,
        packs: state.packs,
        user: state.user,
        promotions: state.promotions,
        stores: state.stores,
        contract: state.contract,
        prismic: state.prismic
    };
};
var mapDispatchToProps = {
    getBasketStock: products/* getBasketStock */.w_,
    getParameters: parameters_getParameters,
    getStock: products/* getStock */.K5,
    getUserOrders: user/* getUserOrders */.uI,
    setFuturePrice: promotions/* setFuturePrice */.mW,
    getUser: user/* getUser */.PR,
    deleteUser: user/* deleteUser */.h8,
    getPromotions: promotions/* getPromotions */.Fh,
    getCountries: countries_getCountries,
    getInProgressContractCSUB: contract/* getInProgressContractCSUB */.UF,
    getInProgressContractSUB: contract/* getInProgressContractSUB */.R0,
    getUserBalance: user/* getUserBalance */.n3,
    getTakeBackStock: takeBack/* getTakeBackStock */.Rl,
    checkWishListExistence: wishList/* checkWishListExistence */.GK
};
var CartManager = function(param) {
    var children = param.children, packs = param.packs, getBasketStock1 = param.getBasketStock, getUserOrders1 = param.getUserOrders, getUser1 = param.getUser, getPromotions1 = param.getPromotions, deleteUser1 = param.deleteUser, setFuturePrice1 = param.setFuturePrice, getParameters1 = param.getParameters, getInProgressContractCSUB1 = param.getInProgressContractCSUB, getInProgressContractSUB1 = param.getInProgressContractSUB, checkWishListExistence1 = param.checkWishListExistence, stores = param.stores, parameters = param.parameters, getCountries1 = param.getCountries, promotions = param.promotions, getStock1 = param.getStock, getTakeBackStock1 = param.getTakeBackStock, user1 = param.user, product1 = param.product, products = param.products, cart = param.cart, prismic = param.prismic, getUserBalance1 = param.getUserBalance;
    var ref27, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    var ref21 = (0,useCart/* useCart */.j)(), deleteCart = ref21.deleteCart, createCart = ref21.createCart, createSubscriptionCart = ref21.createSubscriptionCart, getCart = ref21.getCart, updateCartSubscription = ref21.updateCartSubscription;
    // Hook used to check if component is already mounted, to prevent it to call each useEffect hooks on all rendering
    var didMountProducts = (0,react.useRef)(false);
    var didMountProduct = (0,react.useRef)(false);
    var didMountPacks = (0,react.useRef)(false);
    var router = (0,next_router.useRouter)();
    var warehouseId = (stores === null || stores === void 0 ? void 0 : (ref27 = stores.selectedStore) === null || ref27 === void 0 ? void 0 : ref27.warehouseId) ? stores === null || stores === void 0 ? void 0 : (ref1 = stores.selectedStore) === null || ref1 === void 0 ? void 0 : ref1.warehouseId : process.env.CUSTOM_WAREHOUSE ? process.env.CUSTOM_WAREHOUSE : null;
    var isEnableChooseStartingDate = parameters === null || parameters === void 0 ? void 0 : (ref2 = parameters.items) === null || ref2 === void 0 ? void 0 : ref2.enableChooseStartingDate;
    (0,react.useEffect)(function() {
        if (parameters === null || parameters === void 0 ? void 0 : parameters.items) {
            var ref, ref22, ref23, ref24, ref25, ref26;
            var minimumStartingDays = typeof (parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.minimumStartingDays) !== 'undefined' ? parameters === null || parameters === void 0 ? void 0 : (ref22 = parameters.items) === null || ref22 === void 0 ? void 0 : ref22.minimumStartingDays : 7;
            var minimumLeasingDays = typeof (parameters === null || parameters === void 0 ? void 0 : (ref23 = parameters.items) === null || ref23 === void 0 ? void 0 : ref23.minimumLeasingDays) !== 'undefined' ? parseInt("".concat(parameters === null || parameters === void 0 ? void 0 : (ref24 = parameters.items) === null || ref24 === void 0 ? void 0 : ref24.minimumLeasingDays)) : 2;
            var isSaturdayABusinessDay = parameters === null || parameters === void 0 ? void 0 : (ref25 = parameters.items) === null || ref25 === void 0 ? void 0 : ref25.isSaturdayABusinessDay;
            if (!cart.item && cart.status !== 'cart deleted' && cart.status !== 'error') {
                // no state cart
                if (localStorage.getItem('CartToken')) {
                    getCart();
                } else {
                    // default date
                    if (cart.status !== 'cart deleted for DP') {
                        if (!constants/* isSubscription */.Nn || isEnableChooseStartingDate) {
                            // should include only business days counting from today.
                            var today = dayjs_min_default()();
                            var minStartingDays = minimumStartingDays;
                            for(var i = 0; i < minimumStartingDays; i++){
                                var day = today.day();
                                if (!isSaturdayABusinessDay && day === 5 || day === 6) {
                                    minStartingDays += 1;
                                }
                                today = today.add(1, 'day');
                            }
                            var startDate = dayjs_min_default()().add(minStartingDays, 'day').toDate();
                            var endDate = dayjs_min_default()().add(minStartingDays + minimumLeasingDays - 1, 'day').toDate();
                            // createCart in BDD and redux state
                            createCart(dayjs_min_default()(startDate), dayjs_min_default()(endDate), warehouseId);
                        } else {
                            var startSubscriptionDate = dayjs_min_default()().add(minimumStartingDays, 'day');
                            createSubscriptionCart(dayjs_min_default()(startSubscriptionDate), 1, warehouseId);
                        }
                    }
                }
            } else if (cart.status === 'error' && ((ref26 = cart.error) === null || ref26 === void 0 ? void 0 : ref26.message) === 'Request failed with status code 404' || cart.status === 'cart deleted') {
                // cart not found, create new one
                // remove current Cart token to save the new one
                localStorage.removeItem('CartToken');
                if (!constants/* isSubscription */.Nn) {
                    var savedStartDate = localStorage.getItem("".concat(constants/* SAVED_START_DATE */.zf));
                    var endStartDate = localStorage.getItem("".concat(constants/* SAVED_END_DATE */.mG));
                    var startDate1 = dayjs_min_default()().add(minimumStartingDays, 'day').toDate();
                    var endDate1 = dayjs_min_default()().add(minimumStartingDays + minimumLeasingDays, 'day').toDate();
                    var useSavedDate = false;
                    // createCart in BDD and redux state
                    if (dayjs_min_default()(savedStartDate, 'DD/MM/YYYY').diff(dayjs_min_default()(startDate1), 'day') >= 0) {
                        //saved start date is valid
                        useSavedDate = true;
                    }
                    createCart(savedStartDate && useSavedDate ? dayjs_min_default()(savedStartDate, 'DD/MM/YYYY') : dayjs_min_default()(startDate1), endStartDate && useSavedDate ? dayjs_min_default()(endStartDate, 'DD/MM/YYYY') : dayjs_min_default()(endDate1), warehouseId);
                } else {
                    var savedStartDate1 = localStorage.getItem("".concat(constants/* SAVED_START_DATE */.zf));
                    var startDate2 = dayjs_min_default()().add(minimumStartingDays, 'day');
                    var useSavedDate1 = false;
                    if (dayjs_min_default()(savedStartDate1, 'DD/MM/YYYY').diff(dayjs_min_default()(startDate2), 'day') >= 0) {
                        //saved start date is valid
                        useSavedDate1 = true;
                    }
                    createSubscriptionCart(savedStartDate1 && useSavedDate1 ? dayjs_min_default()(savedStartDate1, 'DD/MM/YYYY') : dayjs_min_default()(startDate2), 1, warehouseId);
                }
            }
        }
        if ((cart === null || cart === void 0 ? void 0 : cart.item) && cart.status === 'cart live' && !localStorage.getItem('CartToken')) {
            localStorage.setItem('CartToken', cart.item.tokenValue);
        }
    }, [
        cart.item,
        cart.status,
        parameters === null || parameters === void 0 ? void 0 : parameters.items
    ]);
    // Delete cart if locale change
    (0,react.useEffect)(function() {
        if (cart === null || cart === void 0 ? void 0 : cart.item) {
            var ref;
            if ((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.locale.substring(0, 2)) !== router.locale) {
                deleteCart();
            }
        }
    }, [
        router.locale
    ]);
    // Update a subscription cart to receive informations about price changes because of current subscription
    (0,react.useEffect)(function() {
        var ref, ref28, ref29;
        // We need to be in subscription mode, we need a cart and a user, and a specific cart state (shipping method not currently selected)
        if (constants/* isSubscription */.Nn && (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.tokenValue) && (user1 === null || user1 === void 0 ? void 0 : (ref28 = user1.user) === null || ref28 === void 0 ? void 0 : ref28.id) && (cart === null || cart === void 0 ? void 0 : (ref29 = cart.item) === null || ref29 === void 0 ? void 0 : ref29.checkoutState) === 'cart' && !(cart === null || cart === void 0 ? void 0 : cart.isUpdated)) {
            updateCartSubscription();
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref3 = cart.item) === null || ref3 === void 0 ? void 0 : ref3.tokenValue,
        user1 === null || user1 === void 0 ? void 0 : (ref4 = user1.user) === null || ref4 === void 0 ? void 0 : ref4.id
    ]);
    // Products Stock Management
    (0,react.useEffect)(function() {
        if (didMountProducts.current === true) {
            var ref, ref30, ref31, ref32, ref33;
            var _products = (products === null || products === void 0 ? void 0 : (ref = products.items) === null || ref === void 0 ? void 0 : ref.items) && (products === null || products === void 0 ? void 0 : (ref30 = products.items) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.items) === null || ref31 === void 0 ? void 0 : ref31.length) > 0 ? products === null || products === void 0 ? void 0 : (ref32 = products.items) === null || ref32 === void 0 ? void 0 : ref32.items : products === null || products === void 0 ? void 0 : (ref33 = products.wishList) === null || ref33 === void 0 ? void 0 : ref33.items;
            if ((_products === null || _products === void 0 ? void 0 : _products.length) > 0 && products.loading === false && cart.status === 'cart live') {
                var ref34, ref35;
                // if we use cumulative products, we don't need to find the stock for the products that has already loaded
                // so we cut the current product stock we have frome the array of SKUs to get only the one we charge
                var SKUArray = [];
                if (products === null || products === void 0 ? void 0 : products.isCumulative) {
                    var newArray = [];
                    newArray = _toConsumableArray(_products);
                    var limit = products.items.limit * (products.items.page - 1);
                    if (products.items.page > 1) {
                        newArray.splice(0, limit);
                    }
                    SKUArray = (0,utils/* getSkus */.ES)(newArray);
                } else {
                    SKUArray = (0,utils/* getSkus */.ES)(_products);
                }
                if (((ref34 = cart.item) === null || ref34 === void 0 ? void 0 : ref34.startLeasingDate) && ((ref35 = cart.item) === null || ref35 === void 0 ? void 0 : ref35.endLeasingDate) && !constants/* isSubscription */.Nn) {
                    if (SKUArray.length > 0) {
                        var ref36, ref37, ref38;
                        var data = {
                            lizeeSKUs: SKUArray,
                            from: dayjs_min_default()((ref36 = cart.item) === null || ref36 === void 0 ? void 0 : ref36.startLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                            to: dayjs_min_default()((ref37 = cart.item) === null || ref37 === void 0 ? void 0 : ref37.endLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        };
                        getStock1(data, warehouseId);
                        getTakeBackStock1(data);
                        (prismic === null || prismic === void 0 ? void 0 : (ref38 = prismic.general) === null || ref38 === void 0 ? void 0 : ref38.wishlist_enabled) && checkWishListExistence1(_products.map(function(p) {
                            return p.id;
                        }));
                    }
                } else {
                    var SKUArray1 = (0,utils/* getSkus */.ES)(_products);
                    if (SKUArray1.length > 0) {
                        var ref39;
                        var data1 = {
                            lizeeSKUs: SKUArray1
                        };
                        getStock1(data1, warehouseId);
                        getTakeBackStock1(data1);
                        (prismic === null || prismic === void 0 ? void 0 : (ref39 = prismic.general) === null || ref39 === void 0 ? void 0 : ref39.wishlist_enabled) && checkWishListExistence1(_products.map(function(p) {
                            return p.id;
                        }));
                    }
                }
            }
        } else didMountProducts.current = true;
    }, [
        products.items,
        (ref5 = cart.item) === null || ref5 === void 0 ? void 0 : ref5.startLeasingDate,
        (ref6 = cart.item) === null || ref6 === void 0 ? void 0 : ref6.endLeasingDate
    ]);
    // Basket Stock Management
    (0,react.useEffect)(function() {
        var ref;
        if ((cart === null || cart === void 0 ? void 0 : cart.item) && ((ref = cart.item.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var ref40, ref41, ref42, ref43;
            var SKUArray = [];
            cart === null || cart === void 0 ? void 0 : (ref40 = cart.item) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.items) === null || ref41 === void 0 ? void 0 : ref41.map(function(item) {
                SKUArray.push(item.product.variants[0].sku);
            });
            if (((ref42 = cart.item) === null || ref42 === void 0 ? void 0 : ref42.startLeasingDate) && ((ref43 = cart.item) === null || ref43 === void 0 ? void 0 : ref43.endLeasingDate) && !constants/* isSubscription */.Nn) {
                if (SKUArray.length > 0) {
                    var ref44, ref45;
                    var data = {
                        lizeeSKUs: SKUArray,
                        from: dayjs_min_default()((ref44 = cart.item) === null || ref44 === void 0 ? void 0 : ref44.startLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                        to: dayjs_min_default()((ref45 = cart.item) === null || ref45 === void 0 ? void 0 : ref45.endLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    };
                    getBasketStock1(data, warehouseId);
                }
            } else {
                if (SKUArray.length > 0) {
                    var data2 = {
                        lizeeSKUs: SKUArray
                    };
                    getBasketStock1(data2, warehouseId);
                }
            }
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref7 = cart.item) === null || ref7 === void 0 ? void 0 : ref7.items,
        (ref8 = cart.item) === null || ref8 === void 0 ? void 0 : ref8.startLeasingDate,
        (ref9 = cart.item) === null || ref9 === void 0 ? void 0 : ref9.endLeasingDate, 
    ]);
    // Single product Stock Management
    (0,react.useEffect)(function() {
        if (didMountProduct.current === true) {
            if (product1.item && product1.loading === false && cart.status === 'cart live') {
                var ref, ref46;
                if (((ref = cart.item) === null || ref === void 0 ? void 0 : ref.startLeasingDate) && ((ref46 = cart.item) === null || ref46 === void 0 ? void 0 : ref46.endLeasingDate) && !constants/* isSubscription */.Nn) {
                    var SKUArray = (0,utils/* getSkus */.ES)(product1.item);
                    if (SKUArray.length > 0) {
                        var ref47, ref48, ref49;
                        var data = {
                            lizeeSKUs: SKUArray,
                            from: dayjs_min_default()((ref47 = cart.item) === null || ref47 === void 0 ? void 0 : ref47.startLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                            to: dayjs_min_default()((ref48 = cart.item) === null || ref48 === void 0 ? void 0 : ref48.endLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        };
                        getStock1(data, warehouseId);
                        (prismic === null || prismic === void 0 ? void 0 : (ref49 = prismic.general) === null || ref49 === void 0 ? void 0 : ref49.wishlist_enabled) && checkWishListExistence1([
                            product1.item.id
                        ]);
                    }
                } else {
                    var SKUArray2 = (0,utils/* getSkus */.ES)(product1.item);
                    if (SKUArray2.length > 0) {
                        var ref50;
                        var data3 = {
                            lizeeSKUs: SKUArray2
                        };
                        getStock1(data3, warehouseId);
                        (prismic === null || prismic === void 0 ? void 0 : (ref50 = prismic.general) === null || ref50 === void 0 ? void 0 : ref50.wishlist_enabled) && checkWishListExistence1([
                            product1.item.id
                        ]);
                    }
                }
            }
        } else didMountProduct.current = true;
    }, [
        product1.item,
        (ref10 = cart.item) === null || ref10 === void 0 ? void 0 : ref10.startLeasingDate,
        (ref11 = cart.item) === null || ref11 === void 0 ? void 0 : ref11.endLeasingDate
    ]);
    // Pack Stock Management
    (0,react.useEffect)(function() {
        if (didMountPacks.current === true) {
            var ref;
            if ((packs === null || packs === void 0 ? void 0 : (ref = packs.items) === null || ref === void 0 ? void 0 : ref.length) > 0 && packs.loading === false && cart.status === 'cart live') {
                var ref51, ref52;
                if (((ref51 = cart.item) === null || ref51 === void 0 ? void 0 : ref51.startLeasingDate) && ((ref52 = cart.item) === null || ref52 === void 0 ? void 0 : ref52.endLeasingDate) && !constants/* isSubscription */.Nn) {
                    var ref53;
                    var data = {};
                    var SKUArray = [];
                    packs === null || packs === void 0 ? void 0 : (ref53 = packs.items) === null || ref53 === void 0 ? void 0 : ref53.map(function(pack) {
                        var SKUs = (0,utils/* getSkus */.ES)(pack.packProducts);
                        var listAssociatedItems = getAssociatedProducts(pack === null || pack === void 0 ? void 0 : pack.productsAssociations);
                        var ProductsSKUs = (0,utils/* getSkus */.ES)(listAssociatedItems);
                        if (SKUArray.length > 0) {
                            if (ProductsSKUs.length > 0) {
                                var _SKUsArray;
                                var SKUsArray = [];
                                (_SKUsArray = SKUsArray).push.apply(_SKUsArray, _toConsumableArray(SKUs).concat(_toConsumableArray(ProductsSKUs)));
                                SKUArray = (0,utils/* arrayUnique */.uW)(SKUArray.concat(SKUsArray));
                            } else {
                                SKUArray = (0,utils/* arrayUnique */.uW)(SKUArray.concat(SKUs));
                            }
                        } else {
                            if (ProductsSKUs.length > 0) {
                                var _SKUsArray1;
                                var SKUsArray1 = [];
                                (_SKUsArray1 = SKUsArray1).push.apply(_SKUsArray1, _toConsumableArray(SKUs).concat(_toConsumableArray(ProductsSKUs)));
                                SKUArray = SKUsArray1;
                            } else {
                                SKUArray = SKUs;
                            }
                        }
                    });
                    if (SKUArray.length > 0) {
                        var ref54, ref55;
                        data = {
                            lizeeSKUs: SKUArray,
                            from: dayjs_min_default()((ref54 = cart.item) === null || ref54 === void 0 ? void 0 : ref54.startLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                            to: dayjs_min_default()((ref55 = cart.item) === null || ref55 === void 0 ? void 0 : ref55.endLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        };
                        getStock1(data, warehouseId);
                    }
                } else {
                    var ref56;
                    var data4 = {};
                    var SKUArray3 = [];
                    (ref56 = packs.items) === null || ref56 === void 0 ? void 0 : ref56.map(function(pack) {
                        var SKUs = (0,utils/* getSkus */.ES)(pack.packProducts);
                        var listAssociatedItems = getAssociatedProducts(pack === null || pack === void 0 ? void 0 : pack.productsAssociations);
                        var ProductsSKUs = (0,utils/* getSkus */.ES)(listAssociatedItems);
                        if (SKUArray3.length > 0) {
                            if (ProductsSKUs.length > 0) {
                                var _SKUsArray;
                                var SKUsArray = [];
                                (_SKUsArray = SKUsArray).push.apply(_SKUsArray, _toConsumableArray(SKUs).concat(_toConsumableArray(ProductsSKUs)));
                                SKUArray3 = (0,utils/* arrayUnique */.uW)(SKUArray3.concat(SKUsArray));
                            } else {
                                SKUArray3 = (0,utils/* arrayUnique */.uW)(SKUArray3.concat(SKUs));
                            }
                        } else {
                            if (ProductsSKUs.length > 0) {
                                var _SKUsArray2;
                                var SKUsArray2 = [];
                                (_SKUsArray2 = SKUsArray2).push.apply(_SKUsArray2, _toConsumableArray(SKUs).concat(_toConsumableArray(ProductsSKUs)));
                                SKUArray3 = SKUsArray2;
                            } else {
                                SKUArray3 = SKUs;
                            }
                        }
                    });
                    if (SKUArray3.length > 0) {
                        data4 = {
                            lizeeSKUs: SKUArray3
                        };
                        getStock1(data4, warehouseId);
                    }
                }
            }
        } else didMountPacks.current = true;
    }, [
        packs.items,
        (ref12 = cart.item) === null || ref12 === void 0 ? void 0 : ref12.startLeasingDate,
        (ref13 = cart.item) === null || ref13 === void 0 ? void 0 : ref13.endLeasingDate
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (user1 === null || user1 === void 0 ? void 0 : (ref = user1.user) === null || ref === void 0 ? void 0 : ref.id) {
            // getUserOrders if user exists and has no order saved in state
            if (!(user1 === null || user1 === void 0 ? void 0 : user1.orders)) {
                getUserOrders1();
                if (false) { var asyncFunc; }
            }
            // getUserBalance if user exists and has no balance saved in state
            if (!(user1 === null || user1 === void 0 ? void 0 : user1.balance)) {
                getUserBalance1();
            }
        }
    }, [
        user1 === null || user1 === void 0 ? void 0 : (ref14 = user1.user) === null || ref14 === void 0 ? void 0 : ref14.id
    ]);
    // handle user automatic connection
    (0,react.useEffect)(function() {
        var ref;
        // We check if there is an existing bearer token but no user state
        if (typeof localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN) !== 'undefined' && localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN) !== null && !(user1 === null || user1 === void 0 ? void 0 : (ref = user1.user) === null || ref === void 0 ? void 0 : ref.id)) {
            // if it is the case (ie client reload or come back on the site after he was connected before)
            var anyNameFunction = function() {
                var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                    var user;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return getUser1();
                            case 2:
                                user = _ctx.sent;
                                // if we receive an error (ie expired token)
                                if (user.type === 'GET_USER_FAILURE') {
                                    // We remove the token from localStorage and we delete everything registered in current redux state
                                    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
                                    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE);
                                    deleteUser1();
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function anyNameFunction() {
                    return _ref.apply(this, arguments);
                };
            }();
            anyNameFunction();
        }
    }, []);
    // get promotions
    (0,react.useEffect)(function() {
        if (typeof (promotions === null || promotions === void 0 ? void 0 : promotions.items) === 'undefined') {
            getPromotions1();
        }
    }, [
        promotions === null || promotions === void 0 ? void 0 : promotions.items
    ]);
    //Futur classic subscription price if connected
    (0,react.useEffect)(function() {
        var ref64, ref57, ref58;
        /*
      Here we watch 3 states : the items in current cart, the promotions
    */ /* Here we have to check if the user exists, that he already have some orders, 
    that we are in classic_subscription, if we have some promotions and if we have products in our customer's cart */ if (false) { var asyncFunction; }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref15 = cart.item) === null || ref15 === void 0 ? void 0 : ref15.items,
        promotions === null || promotions === void 0 ? void 0 : promotions.items,
        user1 === null || user1 === void 0 ? void 0 : (ref16 = user1.user) === null || ref16 === void 0 ? void 0 : ref16.id,
        user1 === null || user1 === void 0 ? void 0 : (ref17 = user1.orders) === null || ref17 === void 0 ? void 0 : ref17.length, 
    ]);
    // Function to destroy any cart created before today's date
    (0,react.useEffect)(function() {
        var ref71;
        if ((cart === null || cart === void 0 ? void 0 : (ref71 = cart.item) === null || ref71 === void 0 ? void 0 : ref71.startLeasingDate) && (parameters === null || parameters === void 0 ? void 0 : parameters.items)) {
            var asyncFunc = function() {
                var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                    var ref, ref68, ref69, ref70, minimumStartingDays, minimumLeasingDays, startDate, endDate;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                minimumStartingDays = typeof (parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.minimumStartingDays) !== 'undefined' ? parameters === null || parameters === void 0 ? void 0 : (ref68 = parameters.items) === null || ref68 === void 0 ? void 0 : ref68.minimumStartingDays : 7;
                                minimumLeasingDays = typeof (parameters === null || parameters === void 0 ? void 0 : (ref69 = parameters.items) === null || ref69 === void 0 ? void 0 : ref69.minimumLeasingDays) !== 'undefined' ? parseInt("".concat(parameters === null || parameters === void 0 ? void 0 : (ref70 = parameters.items) === null || ref70 === void 0 ? void 0 : ref70.minimumLeasingDays)) : 2;
                                startDate = dayjs_min_default()().add(minimumStartingDays, 'day').toDate();
                                endDate = dayjs_min_default()().add(minimumStartingDays + minimumLeasingDays - 1, 'day').toDate();
                                if (!(dayjs_min_default()(cart === null || cart === void 0 ? void 0 : cart.item.startLeasingDate, 'DD/MM/YYYY').diff(startDate, 'day') < 0)) {
                                    _ctx.next = 15;
                                    break;
                                }
                                _ctx.next = 8;
                                return deleteCart();
                            case 8:
                                if (constants/* isSubscription */.Nn) {
                                    _ctx.next = 13;
                                    break;
                                }
                                _ctx.next = 11;
                                return createCart(dayjs_min_default()(startDate), dayjs_min_default()(endDate), warehouseId);
                            case 11:
                                _ctx.next = 15;
                                break;
                            case 13:
                                _ctx.next = 15;
                                return createSubscriptionCart(dayjs_min_default()(startDate), 1, warehouseId);
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function asyncFunc() {
                    return _ref.apply(this, arguments);
                };
            }();
            asyncFunc();
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref18 = cart.item) === null || ref18 === void 0 ? void 0 : ref18.startLeasingDate,
        parameters === null || parameters === void 0 ? void 0 : parameters.items
    ]);
    // Save chosen date
    (0,react.useEffect)(function() {
        var ref, ref72;
        if ((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.startLeasingDate) && (cart === null || cart === void 0 ? void 0 : (ref72 = cart.item) === null || ref72 === void 0 ? void 0 : ref72.endLeasingDate)) {
            var ref73, ref74;
            localStorage.setItem("".concat(constants/* SAVED_START_DATE */.zf), cart === null || cart === void 0 ? void 0 : (ref73 = cart.item) === null || ref73 === void 0 ? void 0 : ref73.startLeasingDate);
            localStorage.setItem("".concat(constants/* SAVED_END_DATE */.mG), cart === null || cart === void 0 ? void 0 : (ref74 = cart.item) === null || ref74 === void 0 ? void 0 : ref74.endLeasingDate);
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref19 = cart.item) === null || ref19 === void 0 ? void 0 : ref19.startLeasingDate,
        cart === null || cart === void 0 ? void 0 : (ref20 = cart.item) === null || ref20 === void 0 ? void 0 : ref20.endLeasingDate
    ]);
    // Get parameters
    (0,react.useEffect)(function() {
        if (!(parameters === null || parameters === void 0 ? void 0 : parameters.items)) {
            getParameters1();
        }
    }, []);
    // Get available shipping countries
    (0,react.useEffect)(function() {
        if (!(parameters === null || parameters === void 0 ? void 0 : parameters.countries)) {
            getCountries1();
        }
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    }));
};
/* harmony default export */ var components_CartManager = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(CartManager));


/***/ }),

/***/ 97506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UF": function() { return /* binding */ contract_getInProgressContractCSUB; },
  "R0": function() { return /* binding */ contract_getInProgressContractSUB; }
});

// UNUSED EXPORTS: ACTIONS, GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE, GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST, GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS, GET_IN_PROGRESS_CONTRACT_SUB_FAILURE, GET_IN_PROGRESS_CONTRACT_SUB_REQUEST, GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS

// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./redux/services/contract.ts




var getInProgressContractCSUB = function(state) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.contractCSUB */.KU.contractCSUB,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE), true),
        isV2: true,
        uid: "?state=".concat(state)
    });
};
var getInProgressContractSUB = function(state) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.contractSUB */.KU.contractSUB,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE), true),
        isV2: true,
        uid: "?state=".concat(state)
    });
};

;// CONCATENATED MODULE: ./redux/actions/contract.ts

var ACTIONS = {
    GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST: 'GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST',
    GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS: 'GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS',
    GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE: 'GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE',
    GET_IN_PROGRESS_CONTRACT_SUB_REQUEST: 'GET_IN_PROGRESS_CONTRACT_SUB_REQUEST',
    GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS: 'GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS',
    GET_IN_PROGRESS_CONTRACT_SUB_FAILURE: 'GET_IN_PROGRESS_CONTRACT_SUB_FAILURE'
};
var GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST = function() {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST
    };
};
var GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS = function(currentContract) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS,
        currentContract: currentContract
    };
};
var GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE,
        err: err
    };
};
function contract_getInProgressContractCSUB(state) {
    return function(dispatch) {
        dispatch(GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST());
        return getInProgressContractCSUB(state).then(function(response) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE(err));
        });
    };
}
var GET_IN_PROGRESS_CONTRACT_SUB_REQUEST = function() {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_SUB_REQUEST
    };
};
var GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS = function(currentContract) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS,
        currentContract: currentContract
    };
};
var GET_IN_PROGRESS_CONTRACT_SUB_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_SUB_FAILURE,
        err: err
    };
};
function contract_getInProgressContractSUB(state) {
    return function(dispatch) {
        dispatch(GET_IN_PROGRESS_CONTRACT_SUB_REQUEST());
        return getInProgressContractSUB(state).then(function(response) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_SUB_FAILURE(err));
        });
    };
}


/***/ }),

/***/ 18919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fh": function() { return /* binding */ promotions_getPromotions; },
  "rs": function() { return /* binding */ setCurrentPromotion; },
  "mW": function() { return /* binding */ setFuturePrice; }
});

// UNUSED EXPORTS: ACTIONS, GET_PROMOTIONS_FAILURE, GET_PROMOTIONS_REQUEST, GET_PROMOTIONS_SUCCESS, SET_CURRENT_PROMOTION, SET_FUTUR_PRICE

// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/promotionsService.ts


var getPromotions = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.promotions */.KU.promotions
    });
};

;// CONCATENATED MODULE: ./redux/actions/promotions.ts

var ACTIONS = {
    GET_PROMOTIONS_REQUEST: 'GET_PROMOTIONS_REQUEST',
    GET_PROMOTIONS_SUCCESS: 'GET_PROMOTIONS_SUCCESS',
    GET_PROMOTIONS_FAILURE: 'GET_PROMOTIONS_FAILURE',
    SET_FUTUR_PRICE: 'SET_FUTUR_PRICE',
    SET_CURRENT_PROMOTION: 'SET_CURRENT_PROMOTION'
};
var GET_PROMOTIONS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PROMOTIONS_REQUEST
    };
};
var GET_PROMOTIONS_SUCCESS = function(promotions) {
    return {
        type: ACTIONS.GET_PROMOTIONS_SUCCESS,
        promotions: promotions
    };
};
var GET_PROMOTIONS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PROMOTIONS_FAILURE,
        err: err
    };
};
function promotions_getPromotions() {
    return function(dispatch) {
        dispatch(GET_PROMOTIONS_REQUEST());
        return getPromotions().then(function(response) {
            return dispatch(GET_PROMOTIONS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PROMOTIONS_FAILURE(err));
        });
    };
}
var SET_FUTUR_PRICE = function(price) {
    return {
        type: ACTIONS.SET_FUTUR_PRICE,
        price: price
    };
};
var SET_CURRENT_PROMOTION = function(currentPromotion) {
    return {
        type: ACTIONS.SET_CURRENT_PROMOTION,
        currentPromotion: currentPromotion
    };
};
function setCurrentPromotion(currentPromotion) {
    return function(dispatch) {
        dispatch(SET_CURRENT_PROMOTION(currentPromotion));
    };
}
function setFuturePrice(price) {
    return function(dispatch) {
        dispatch(SET_FUTUR_PRICE(price));
    };
}


/***/ })

}]);